// Tomkownik frontend — TSX Web Components entry point

export { showToast } from './components/tmk-toast.tsx';
export { TmkTaskList } from './components/tmk-task-list.tsx';
export { TmkTagsManager } from './components/tmk-tags-manager.tsx';
export { TmkCalendar } from './components/tmk-calendar.tsx';
export { TmkTaskDetail } from './components/tmk-task-detail.tsx';
export { TmkStats } from './components/tmk-stats.tsx';
export { TagsAPI, TasksAPI, ViewsAPI } from './api.ts';
export { offlineBannerText } from './offline-core.ts';
import './components/tmk-search-bar.tsx';
import { UndoManager } from './undo.ts';

// PWA: service worker z powłoką offline (spec/pwa.md). Rejestracja po 'load',
// żeby nie konkurować o sieć ze startem aplikacji.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err: unknown) => {
      console.warn('Service worker: rejestracja nieudana', err);
    });
  });
}

// Block text selection on touch devices (iOS Safari ignores CSS user-select)
if ('ontouchstart' in window) {
  document.addEventListener('selectstart', (e) => {
    const tag = (e.target as HTMLElement)?.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA') return;
    e.preventDefault();
  });
}

// ─── Undo / Redo UI ──────────────────────────────────────────────────

/**
 * Lista po undo/redo odświeża się z bieżącymi filtrami i trybem (spec/lista-zadan.md → Undo / Redo).
 * Incydent 2026-09-14: render({}) zerował filtry — lista pokazywała wszystkie zamknięte zadania.
 */
function refreshTaskList() {
  const taskList = document.querySelector('tmk-task-list') as (HTMLElement & { refresh: () => Promise<void> }) | null;
  if (taskList) taskList.refresh();
}

function updateUndoButtons() {
  const undoBtn = document.getElementById('btn-undo') as HTMLButtonElement | null;
  const redoBtn = document.getElementById('btn-redo') as HTMLButtonElement | null;
  if (undoBtn) undoBtn.disabled = !UndoManager.canUndo();
  if (redoBtn) redoBtn.disabled = !UndoManager.canRedo();
}

UndoManager.onChanged = updateUndoButtons;

document.addEventListener('DOMContentLoaded', () => {
  updateUndoButtons();

  document.getElementById('btn-undo')?.addEventListener('click', async () => {
    if (await UndoManager.undo()) {
      refreshTaskList();
    }
  });

  document.getElementById('btn-redo')?.addEventListener('click', async () => {
    if (await UndoManager.redo()) {
      refreshTaskList();
    }
  });

  // Keyboard shortcuts: Ctrl+Z / Ctrl+Shift+Z
  document.addEventListener('keydown', async (e) => {
    if (!e.ctrlKey || e.altKey || e.metaKey) return;
    const tag = (e.target as HTMLElement)?.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA') return;

    if (e.key === 'z' && !e.shiftKey) {
      e.preventDefault();
      if (await UndoManager.undo()) {
        refreshTaskList();
      }
    } else if ((e.key === 'z' && e.shiftKey) || e.key === 'y') {
      e.preventDefault();
      if (await UndoManager.redo()) {
        refreshTaskList();
      }
    }
  });
});
